import { useState } from 'react';
import {
  Box,
  Collapse,
  Container,
  Divider,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material';
import ChevronRightIcon from '@untitled-ui/icons-react/build/esm/ChevronRight';

const faqs = [
  {
    question: '어떤 데이터를 기반으로 하나요?',
    answer:
      '매매·전세 지수, 매물수, 실거래가, 시세, 전세가율, 입주물량, 미분양, 인구·세대수, 통화량 등 22개 이상의 공신력 있는 지표를 자동 수집하여 통합 분석합니다.',
  },
  {
    question: '아파트 필터는 어떤 조건을 지원하나요?',
    answer:
      '년식, 세대수, 평형, 시세(매매가), 평당가, 전세가율, 매전갭, 재건축 여부까지 세밀한 조건 설정이 가능합니다. 지도 기반 검색과 멀티지역 필터도 제공됩니다.',
  },
  {
    question: '분석 결과를 저장할 수 있나요?',
    answer:
      '네, 차트와 지도로 만든 분석을 저장하고 분석 노트에 넣을 수 있습니다. 관심 지역과 아파트의 선정 이유, 생각을 함께 기록하고, 노트를 다시 열어 데이터의 변화와 내 판단을 꾸준히 점검할 수 있습니다.',
  },
  {
    question: '모바일에서도 사용 가능한가요?',
    answer:
      '네, 모바일 브라우저에서 최적화된 화면으로 이용 가능합니다. 멀티 분석 등 일부 고급 기능은 PC 환경을 권장합니다.',
  },
  {
    question: '무료로 이용할 수 있나요?',
    answer:
      '회원가입 시 체험 기간이 제공됩니다. 체험 기간에는 서비스를 이용해 볼 수 있으며, 이후에는 이용권을 결제하여 계속 이용할 수 있습니다.',
  },
  {
    question: '결제 후 바로 이용할 수 있나요?',
    answer:
      '네, 결제 완료 즉시 이용 기간이 시작되거나 기존 잔여 이용 기간 뒤에 추가됩니다. 실제 접속 여부와 관계없이 이용 기간은 경과합니다.',
  },
  {
    question: '단순 변심으로 환불할 수 있나요?',
    answer:
      '환불 요청 시 이미 시작된 이용권은 결제 완료일부터 환불 요청일까지 경과한 기간에 해당하는 금액을 공제하고 잔액을 환불합니다. 기존 잔여 기간 뒤에 추가되어 아직 시작되지 않은 이용권은 전액 환불합니다. 구체적인 청약철회와 환불은 관련 법령 및 서비스 이용약관에 따라 처리됩니다.',
  },
];

const FaqItem = ({ question, answer, isOpen, onToggle }) => (
  <Box>
    <Stack
      onClick={onToggle}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
      sx={{
        cursor: 'pointer',
        py: 3,
        '&:hover': { color: 'primary.main' },
        transition: 'color 0.2s',
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 600 }}
      >
        {question}
      </Typography>
      <SvgIcon
        sx={{
          fontSize: 20,
          flexShrink: 0,
          transition: 'transform 0.2s',
          transform: isOpen ? 'rotate(90deg)' : 'none',
        }}
      >
        <ChevronRightIcon />
      </SvgIcon>
    </Stack>
    <Collapse in={isOpen}>
      <Typography
        color="text.secondary"
        variant="body2"
        sx={{ pb: 3, lineHeight: 1.8 }}
      >
        {answer}
      </Typography>
    </Collapse>
    <Divider />
  </Box>
);

export const HomeFaqs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <Box
      sx={{
        py: { xs: 10, md: 16 },
        backgroundColor: (theme) =>
          theme.palette.mode === 'dark' ? 'neutral.900' : 'neutral.50',
      }}
    >
      <Container maxWidth="md">
        <Stack
          spacing={2}
          sx={{ mb: 6, textAlign: 'center' }}
        >
          <Typography
            variant="overline"
            sx={{ color: 'primary.main', fontWeight: 700, letterSpacing: 2 }}
          >
            FAQ
          </Typography>
          <Typography
            variant="h2"
            sx={{ fontWeight: 800, fontSize: { xs: 28, md: 40 } }}
          >
            자주 묻는 질문
          </Typography>
        </Stack>

        <Box>
          <Divider />
          {faqs.map((faq, index) => (
            <FaqItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onToggle={() => setOpenIndex(openIndex === index ? null : index)}
            />
          ))}
        </Box>
      </Container>
    </Box>
  );
};
